import { gql } from '@apollo/client';

export const REDEFINIR_SENHA = gql`
  mutation ($input: UserUpdatePasswordInput!, $session: ID!) {
    redefinirSenha(input: $input, session: $session)
  }
`;
